import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

import { t } from 'ember-intl'
import { concat } from '@ember/helper'
import { eq } from 'ember-truth-helpers'

interface Args {
  status: string
}

interface Signature {
  Element: HTMLSpanElement
  Args: Args
}

export class AssignmentStatus extends Component<Signature> {
  get statusClassNames() {
    switch (this.args.status) {
      case 'scheduled':
      case 'not-started':
      case 'pending':
        return 'border-oceany-blue-400 bg-oceany-blue-50 text-oceany-blue-400'
      case 'running':
      case 'in-progress':
      case 'active':
        return 'border-deep-orange-350 bg-deep-orange-50 text-deep-orange-350'
      case 'expired':
        return 'border-dusty-black-300 bg-dusty-black-50 text-dusty-black-300'
      case 'completed':
        return 'border-forest-green-350 bg-forest-green-50 text-forest-green-350'
      default:
        return ''
    }
  }

  <template>
    <span
      class="overflow-hidden rounded-3xl border px-3 py-1 text-sm font-bold whitespace-nowrap uppercase
        {{this.statusClassNames}}"
      data-status={{@status}}
      ...attributes
    >
      {{t (concat "assignments.manage.studentStatus." @status)}}
      {{#if (eq @status "completed")}}
        <PhosphorIcon @icon="phosphor-check-bold" class="print:hidden" />
      {{/if}}
    </span>
  </template>
}

export default AssignmentStatus
